import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

// a company's group order defaults (tasks#222): one row per company, created on its first save
class CompanyGroupOrderSettings extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/company-group-order-settings'
    }

    // the company's row, or null when it has none yet
    forCompany(companyIri) {
        // null only for a successful answer without a row: a failed or unusable answer rejects, so the
        // calendar never mistakes it for "the company has no defaults"
        return this.list({ company: companyIri }).then((response) => {
            const members = response?.['hydra:member']
            if (!Array.isArray(members)) {
                throw new Error('Group order settings could not be loaded')
            }
            return members[0] || null
        })
    }
}

export default new CompanyGroupOrderSettings()
